import axios from "./index";
import { ERROR1 } from "../constants";

export const getUserLogs = async () => {
    try {
        const { data } = await axios({
            method: "GET",
            url: "/profile/user/logs"
        });
        return {
            succeed: true,
            data: data.data
        };
    } catch (err) {
        let errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;

        if (err?.response?.data?.errorCode === "500 INTERNAL_SERVER_ERROR") {
            errMsg =
                "There's something wrong retrieving the list of team members. Please try again later.";
        }
        return {
            succeed: false,
            message: errMsg
        };
    }
};
